import { Outlet, NavLink } from "react-router-dom";
import { LayoutGrid, Users, Calendar, Flag, MessageSquare, Wrench } from "lucide-react";

const TABS = [
  { to: "/admin",          label: "Overview", icon: LayoutGrid, end: true },
  { to: "/admin/users",    label: "Users",    icon: Users },
  { to: "/admin/events",   label: "Events",   icon: Calendar },
  { to: "/admin/reports",  label: "Reports",  icon: Flag },
  { to: "/admin/feedback", label: "Feedback", icon: MessageSquare },
  { to: "/admin/backfill-locations", label: "Backfill", icon: Wrench },
];

export default function AdminShell() {
  return (
    <div className="bg-paper min-h-[calc(100vh-4rem)]">
      <div className="max-w-7xl mx-auto px-5 md:px-10 pt-6 md:pt-10">
        <div className="flex items-end justify-between gap-4 mb-6">
          <div>
            <span className="inline-block text-[11px] font-extrabold uppercase tracking-[0.25em] text-ink/60 mb-2">
              Admin
            </span>
            <h1 className="font-display text-4xl md:text-5xl leading-[0.95] tracking-tight">
              Mission control.
            </h1>
          </div>
          <span className="inline-flex items-center gap-1.5 bg-lime border-[2.5px] border-ink rounded-full px-3 py-1 text-[10px] font-extrabold uppercase tracking-widest shadow-pop-sm">
            Internal
          </span>
        </div>

        {/* Tabs */}
        <div className="-mx-5 md:mx-0 px-5 md:px-0 flex gap-2 overflow-x-auto no-scrollbar pb-1 mb-6">
          {TABS.map((t) => {
            const Icon = t.icon;
            return (
              <NavLink
                key={t.to}
                to={t.to}
                end={t.end}
                data-testid={`admin-tab-${t.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `shrink-0 inline-flex items-center gap-2 border-[2.5px] border-ink rounded-full px-4 py-2.5 text-sm font-extrabold uppercase tracking-widest transition-colors ${
                    isActive ? "bg-ink text-paper" : "bg-paper text-ink hover:bg-ink/5"
                  }`
                }
              >
                <Icon size={13} strokeWidth={2.2} /> {t.label}
              </NavLink>
            );
          })}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 md:px-10 pb-20">
        <Outlet />
      </div>
    </div>
  );
}
